type LegacyTextUtilsUsageWindow = Window & {
  __legacyTextUtilsUsagePending?: boolean;
  __legacyTextUtilsUsageReported?: boolean;
  __reportLegacyTextUtilsUsage?: () => void;
};

const PENDING_STORAGE_KEY = 'legacy-text-utils-usage-pending';

function getUsageWindow(): LegacyTextUtilsUsageWindow {
  return window as LegacyTextUtilsUsageWindow;
}

function hasPersistedUsage(): boolean {
  try {
    return window.sessionStorage.getItem(PENDING_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

function persistUsage(usageWindow: LegacyTextUtilsUsageWindow): boolean {
  usageWindow.__legacyTextUtilsUsagePending = true;
  try {
    window.sessionStorage.setItem(PENDING_STORAGE_KEY, '1');
    return true;
  } catch {
    return false;
  }
}

function clearPersistedUsage(usageWindow: LegacyTextUtilsUsageWindow): boolean {
  delete usageWindow.__legacyTextUtilsUsagePending;
  try {
    window.sessionStorage.removeItem(PENDING_STORAGE_KEY);
    return true;
  } catch {
    return false;
  }
}

function invokeReporter(reporter: () => void): boolean {
  try {
    reporter();
    return true;
  } catch {
    return false;
  }
}

export function reportLegacyTextUtilsUsage(): void {
  const usageWindow = getUsageWindow();
  if (usageWindow.__legacyTextUtilsUsageReported) {
    return;
  }

  usageWindow.__legacyTextUtilsUsageReported = true;
  const reporter = usageWindow.__reportLegacyTextUtilsUsage;
  if (!reporter || !invokeReporter(reporter)) {
    persistUsage(usageWindow);
  }
}

export function setLegacyTextUtilsUsageReporter(reporter: () => void): void {
  const usageWindow = getUsageWindow();
  usageWindow.__reportLegacyTextUtilsUsage = reporter;

  if (
    (usageWindow.__legacyTextUtilsUsagePending || hasPersistedUsage()) &&
    invokeReporter(reporter)
  ) {
    usageWindow.__legacyTextUtilsUsageReported = true;
    clearPersistedUsage(usageWindow);
  }
}
